import PortfolioName from "./PortfolioNameContainer";

export default PortfolioName;
